const init = {
    loading: false,
    roadXmlFiles: null,
    error: undefined,
    isSaved: false,
    xmlFileData: null
  };
  
  export const roadXmlFiles = (state = init, action) => {
    switch (action.type) {
      case "FETCH_ROAD_XML_FILES_START":
        return { ...state, loading: true };
      case "FETCH_ROAD_XML_FILES_SUCCESS":
        return { ...state, loading: false, roadXmlFiles: action.payload };
      case "FETCH_ROAD_XML_FILES_FAILURE":
        return { ...state, loading: false, error: action.payload };
      case "DOWNLOAD_ROAD_XML_FILES_START":
        return { ...state, loading: true };
      case "DOWNLOAD_ROAD_XML_FILES_SUCCESS":
        return { ...state, loading: false, isSaved: true,xmlFileData: action.payload };
      case "DOWNLOAD_ROAD_XML_FILES_FAILURE":
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  